var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{staticClass:"mb-6",attrs:{"header-title":_vm.$t('EXPORT_WIZARD.STEP_1.TITLE'),"header-content":_vm.$t('EXPORT_WIZARD.STEP_1.DESC')}}),_vm._v(" "),_c('div',[_c('input-radio-list',{attrs:{"name":"widget-screen","items":_vm.categories},on:{"change":_vm.onChangeCategory}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }